import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

// const options = zod.enum([...Permissions.options]);

export const LprGroupFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string({ required_error: MANDATORY_FIELD }).min(1, MANDATORY_FIELD),
  description: zod.string().optional(),
  plates: zod.array(zod.string()),
  isSendAllEvents: zod.boolean(),
});
